import { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Button, Checkbox, Col, Form, FormItem, Input, Password, Row, Text } from '@/components/atoms';
import { Divider, message, Spin } from 'antd';
import { Store } from 'antd/lib/form/interface';
import { API_AUTH_LOGIN, PATH_AUTH_FORGOT_ACCOUNT, PATH_AUTH_FORGOT_PASSWORD, PATH_AUTH_SIGNUP, PATH_TAX } from '@/constants/constant';
import { ErrorMessage } from '@/constants/message';

import { useAppDispatch } from '@/store';
import { getMe, setToken } from '@/features/account/accountSlice';
import api from '@/api';
import { useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';
import Layout from '@/components/atoms/layout/Layout';
import Title from '@/components/atoms/text/Title';

/** @link PATH_AUTH_LOGIN */
const LoginPage = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const { loading: accountLoading } = useSelector((state: RootState) => state.account);
  const [error, setError] = useState();

  const onRequestLogin = (values: Store) => {
    setLoading(true);
    api
      .post(API_AUTH_LOGIN, 'pauth.PbLoginRequest', { email: values.account, password: values.password })
      .then(({ data }) => {
        setLoading(false);
        dispatch(setToken(data));
        dispatch(getMe());
        history.push(PATH_TAX);
      })
      .catch((e: any) => {
        setLoading(false);
        setError(e?.data?.message ?? ErrorMessage.network.disconnected);
      });
  };

  useEffect(() => {
    if (error) {
      message.error(error);
      setError(undefined);
    }
  }, [error]);

  return (
    <Layout>
      <Title>PINCAR Biz Center</Title>
      <Text className="sub-title">핀카와 함께 스마트한 일상을 만들어보세요</Text>
      <Spin spinning={accountLoading}>
        <Form onFinish={onRequestLogin}>
          <FormItem
            name="account"
            rules={[
              { required: true, message: ErrorMessage.auth.account.empty },
              { type: 'email', message: ErrorMessage.auth.account.pattern },
            ]}
          >
            <Input placeholder="이메일 주소 또는 아이디" />
          </FormItem>
          <FormItem name="password" rules={[{ required: true, message: ErrorMessage.auth.password.empty }]}>
            <Password maxLength={80} placeholder="비밀번호" />
          </FormItem>
          <FormItem>
            <Button htmlType="submit" size="large" type="success" block disabled={loading} loading={loading}>
              로그인
            </Button>
          </FormItem>
          <Row justify="space-between" align="top" className="option-row">
            <Col>
              <FormItem name="remember" valuePropName="checked">
                <Checkbox>로그인 상태 유지</Checkbox>
              </FormItem>
            </Col>
            <Col className="find-group">
              <Link className="link" to={PATH_AUTH_FORGOT_ACCOUNT}>
                계정 찾기
              </Link>
              <Divider type="vertical" />
              <Link className="link" to={PATH_AUTH_FORGOT_PASSWORD}>
                비밀번호 찾기
              </Link>
            </Col>
          </Row>
        </Form>
      </Spin>
      <Text className="text-center sub-text">계정이 없으신가요?</Text>
      <Link className="link success-link" to={PATH_AUTH_SIGNUP}>
        회원가입 바로가기
      </Link>
    </Layout>
  );
};

export default LoginPage;
